export const IconHideEye: {
  name: 'icon_hide_eye-a7f76fd54448'
} = {
  name: 'icon_hide_eye-a7f76fd54448'
}
